<div *ngIf="documenttype">
  <app-documenttype-editform [editedDocumenttype]="documenttype">
  </app-documenttype-editform>
</div>
